import type { WikiTopic } from "../types.js";
import { familyAndHorizon } from "./family-and-horizon.js";
import { howASignalIsMade } from "./how-a-signal-is-made.js";
import { severity } from "./severity.js";

/**
 * The three concept topics, in reading order.
 *
 * How a row gets written, what its two labels mean, and why almost none of
 * them reach a phone. The rail shows them in this order because each one
 * assumes the last: family is a column on the row the first topic describes,
 * and severity is the column that decides what the second one's rows do next.
 */
export const conceptsPipeline: readonly WikiTopic[] = [
  howASignalIsMade,
  familyAndHorizon,
  severity,
];
